export default __webpack_public_path__ + "static/media/gs8-dashboard.b2f339f0.png";